export const aboutInfo = {
  brandName: '51吃瓜app',
  brandIntro: '全网最火爆的娱乐资讯平台',
  description: '51吃瓜app成立于2023年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为全国吃瓜群众提供最新、最全、最热的娱乐资讯服务。从明星爆料到网红黑料，从聊天记录泄露到每日大赛盘点，51吃瓜app汇聚了全网最劲爆的吃瓜内容。',
  mission: '让每一个吃瓜群众都能第一时间吃到最新鲜的瓜',
  history: [
    { year: '2023年3月', event: '51吃瓜app正式上线，首月用户突破10万' },
    { year: '2023年8月', event: '推出每日大赛功能，日活用户突破50万' },
    { year: '2024年1月', event: '用户总数突破500万，成为国内最大的吃瓜资讯平台' },
    { year: '2024年6月', event: '引入AI智能推荐算法，内容分发效率提升300%' },
    { year: '2025年3月', event: '累计用户突破2000万，覆盖全国所有省份' },
    { year: '2026年1月', event: '推出视频爆料功能，开启吃瓜新时代' }
  ],
  honors: [
    { title: '年度最佳娱乐应用', icon: 'ri-trophy-line', description: '2025年度应用商店评选' },
    { title: '用户最喜爱资讯平台', icon: 'ri-heart-line', description: '蝉联两届用户票选第一' },
    { title: '最具影响力新媒体', icon: 'ri-flashlight-line', description: '中国新媒体峰会评选' },
    { title: '内容安全标杆企业', icon: 'ri-shield-check-line', description: '网络信息安全管理认证' }
  ],
  mediaReviews: [
    {
      reviewer: '科技日报',
      role: '权威科技媒体',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20news%20icon%20avatar%2C%20newspaper%20theme%2C%20minimalist%20design%2C%20warm%20gray%20colors%2C%20clean%20illustration&width=100&height=100&seq=media-avatar-01&orientation=squarish',
      quote: '51吃瓜app凭借精准的内容推荐和活跃的社区氛围，成功抓住了年轻用户对娱乐资讯的旺盛需求，是国内娱乐资讯赛道的一匹黑马。',
      rating: 4.8
    },
    {
      reviewer: '互联网观察',
      role: '行业分析媒体',
      avatar: 'https://readdy.ai/api/search-image?query=Tech%20analysis%20icon%20avatar%2C%20magnifying%20glass%20theme%2C%20minimalist%20design%2C%20warm%20orange%20colors&width=100&height=100&seq=media-avatar-02&orientation=squarish',
      quote: '在信息碎片化时代，51吃瓜app以其独特的"吃瓜"文化定位和高效的内容聚合能力，为娱乐资讯行业树立了新的标杆。',
      rating: 4.6
    },
    {
      reviewer: '新经济周刊',
      role: '财经媒体',
      avatar: 'https://readdy.ai/api/search-image?query=Business%20magazine%20icon%20avatar%2C%20professional%20theme%2C%20minimalist%20design%2C%20warm%20brown%20colors&width=100&height=100&seq=media-avatar-03&orientation=squarish',
      quote: '从零到两千万用户，51吃瓜app只用了不到三年时间。其快速增长背后，是对用户需求的精准把握和对内容质量的严格把控。',
      rating: 4.7
    }
  ],
  contact: {
    email: 'hello@shlvtian.cn',
    phone: '400-888-5151',
    address: '北京市朝阳区望京科技园区A座15层',
    wechat: '51chigua_official',
    weibo: '@51吃瓜app官方微博'
  }
};

export const teamMembers = [
  {
    name: '张明远',
    role: '创始人 & CEO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%2C%20modern%20office%20background%2C%20confident%20expression%2C%20warm%20lighting%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-01&orientation=squarish',
    description: '连续创业者，前知名互联网公司高管'
  },
  {
    name: '李思雨',
    role: '联合创始人 & CTO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20tech%20leader%20portrait%2C%20modern%20tech%20office%20background%2C%20friendly%20smile%2C%20warm%20lighting%2C%20corporate%20headshot&width=200&height=200&seq=team-02&orientation=squarish',
    description: '前字节跳动高级技术专家，AI算法博士'
  },
  {
    name: '王浩然',
    role: '内容总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20editor%20portrait%2C%20creative%20office%20background%2C%20thoughtful%20expression%2C%20warm%20lighting%2C%20media%20professional&width=200&height=200&seq=team-03&orientation=squarish',
    description: '资深媒体人，前新浪娱乐主编'
  },
  {
    name: '陈小艺',
    role: '运营总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20marketing%20portrait%2C%20modern%20office%2C%20energetic%20smile%2C%20warm%20lighting%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-04&orientation=squarish',
    description: '社区运营专家，打造过多个月活千万级产品'
  }
];